let cache: Record<string, any> = {};

export async function getQlikConfig(): Promise<any | null> {
  return new Promise(async (resolve, reject) => {
    try {
      const env = import.meta.env.MODE || "development"; // Get the current environment
      const baseUrl = import.meta.env.VITE_BASE || "/";
      const configFile = `${baseUrl}config/config.${env}.json`;

      const response = await fetch(configFile)
      const config = await response.json()

      // Store the fetched data in the cache
      cache = config;

      resolve(config)
    } catch (error) {
      console.error("Failed to load config:", error)
      reject(error);
    }
  });
}

export async function getQlikResources(type: any): Promise<any | null> {
  

  // console.log(`Cache miss for type: ${type}`);

  return new Promise(async (resolve, reject) => {
      try {
        // const env = import.meta.env.MODE || "development"; // Get the current environment
        // const configFile = `./config/config.${env}.json`;

        // const response = await fetch(configFile)
        const config = Object.keys(cache).length > 0 ? cache : await getQlikConfig()

        // Store the fetched data in the cache
        // cache[type] = config[type];

        resolve(config[type])
      } catch (error) {
        console.error("Failed to load config:", error)
        reject(error);
      }
    });
}